<template>
  <div>
    <main class="container-wrap">
    <section id="js-intro-cm" class="intro-top-wrap">
        <Slick class="intro-slider-wrap slick-slider slick-dotted" ref="slickIntro" :options="slickIntro">            
            <!-- <div class="slick-slide">
                <div class="content">
                    <figure class="text_h1"><img src="../images/slider_text_h1.7b3416d.png"></figure>
                    <div class="slider-animation-8">
                        <figure class="h-bg-a"><img src="../images/slider_h_bg_a.5c91b80.png"></figure>
                        <figure class="h-bg-b"><img src="../images/slider_h_bg_b.2e9d889.png"></figure>
                        <figure class="h-bg-c"><img src="../images/slider_h_bg_c.82d6e92.png"></figure>
                        <figure class="h-bg-d"><img src="../images/slider_h_bg_d.594cbf8.png"></figure>
                        <figure class="h01"><img src="../images/slider_h01.9ee125a.png"></figure>
                        <figure class="h02"><img src="../images/slider_h02.17e3548.png"></figure>
                        <figure class="h03-a"><img src="../images/slider_h03_a.cdb2e28.png"></figure>
                        <figure class="h03-b"><img src="../images/slider_h03_b.a262a55.png"></figure>
                        <figure class="h03-c"><img src="../images/slider_h03_c.9c2dd4b.png"></figure>
                        <figure class="h04"><img src="../images/slider_h04.c4e2dfb.png"></figure>
                        <figure class="h05"><img src="../images/slider_h05.01ffddf.png"></figure>
                        <figure class="h06"><img src="../images/slider_h06.1b54df0.png"></figure>
                    </div>
                </div>
            </div> -->
            <!-- <div class="slick-slide">
                <div class="content">
                    <figure class="text_g1"><img src="../images/slider_text_g1.9f3f4ee.png"></figure>
                    <figure class="text_g2"><img src="../images/slider_text_g2.776cca1.png"></figure>
                    <div class="slider-animation-7">
                        <figure class="g01"><img src="../images/slider_g01.a882c49.png"></figure>
                        <figure class="g02"><img src="../images/slider_g02.6128618.png"></figure>
                        <figure class="g02_2"><img src="../images/slider_g02_2.71aad75.png"></figure>
                        <figure class="g03"><img src="../images/slider_g03.01c5203.png"></figure>
                        <figure class="g04"><img src="../images/slider_g04.0dbbe11.png"></figure>
                        <figure class="g05"><img class="demo-dg6" src="../images/slider_g05.a7f26e7.png"></figure>
                        <figure class="g06"><img class="demo-dg6" src="../images/slider_g06.69035b8.png"> <img
                                class="demo-tg6" src="../images/slider_g06_t.025b770.png"> <img class="demo-mg6"
                                src="../images/slider_g06_m.7d2b369.png"></figure>
                        <figure class="g07"><img class="demo-dg7" src="../images/slider_g07.ddc0e1f.png"></figure>
                        <figure class="g08"><img class="demo-dg7" src="../images/slider_g08.9aaa3a5.png"> <img
                                class="demo-tg7" src="../images/slider_g08_2.9400693.png"></figure>
                        <figure class="g09"><img class="demo-dg1" src="../images/slider_g09.74365c8.png"></figure>
                        <figure class="g10"><img src="../images/slider_g10.21f4cdd.png"></figure>
                    </div>
                </div>
            </div> -->
            <!-- <div class="slick-slide">
                <div class="content">
                    <figure class="text_f1"><img src="../images/slider_text_f1.ebe0636.png"></figure>
                    <div class="slider-animation-6">
                        <figure class="f01"><img class="demo-d2" src="../images/slider_f01.b015a28.png"> <img
                                class="demo-t" src="../images/slider_f01_t.6f9b86f.png"></figure>
                        <figure class="f02"><img src="../images/slider_f02.36b8b75.png"></figure>
                        <figure class="f02_2"><img src="../images/slider_f02_2.7131427.png"></figure>
                        <figure class="f03"><img src="../images/slider_f03.c52c3ff.png"></figure>
                        <figure class="f04"><img src="../images/slider_f04.69475ed.png"></figure>
                        <figure class="f05"><img src="../images/slider_f05.2225995.png"></figure>
                        <figure class="f06"><img class="demo-d2" src="../images/slider_f06.555e0b9.png"></figure>
                        <figure class="f07"><img src="../images/slider_f07.01f5b5e.png"></figure>
                        <figure class="f08"><img src="../images/slider_f08.fdeaaf1.png"></figure>
                        <figure class="f09"><img src="../images/slider_f09.b710f37.png"></figure>
                    </div>
                </div>
            </div> -->
            <div class="slick-slide">
                <div class="content">
                    <figure class="text_a1"><img class="lazyLoad isLoaded"
                            :src="getCurrentLanguage() === 'en'? require('../images/en_slider_text_a1.8275d8c.png') : require('../images/slider_text_a1.8275d8c.png')">
                    </figure>
                    <!-- <figure class="text_a2"><img class="lazyLoad isLoaded" src="../images/slider_text_a2.aa82616.png">
                    </figure> -->
                    <div class="slider-animation-1">
                        <figure class="a01-l"><img class="lazyLoad isLoaded" src="../images/slider_a01_l.45fa4e2.png">
                        </figure>
                        <figure class="a01-r"><img class="lazyLoad isLoaded" src="../images/slider_a01_r.38adc54.png">
                        </figure>
                        <figure class="a02"><img class="demo-d lazyLoad isLoaded" src="../images/slider_a02.b1d6913.png"> <img
                                src="../images/slider_a02_m.0cd9381.png" class="demo-m lazyLoad"></figure>
                        <figure class="a03"><img class="lazyLoad isLoaded" src="../images/slider_a03.86a715b.png">
                        </figure>
                    </div>
                </div>
            </div>
            <div class="slick-slide">
                <div class="content">
                    <figure class="text_b1"><img class="lazyLoad isLoaded" 
                        :src="getCurrentLanguage() === 'en'? require('../images/en-slider_text_b1.2565fbd.png') : require('../images/../images/slider_text_b1.2565fbd.png')">
                    </figure>
                    <figure class="text_b2"><img class="lazyLoad isLoaded" src="../images/slider_text_b2.8425a19.png">
                    </figure>
                    <div class="slider-animation-2">
                        <figure class="b01"><img class="lazyLoad isLoaded" src="../images/slider_b01.bc7524a.png">
                        </figure>
                        <figure class="b02"><img class="lazyLoad isLoaded" src="../images/slider_b02.d4210b7.png">
                        </figure>
                        <figure class="b03"><img class="lazyLoad isLoaded" src="../images/slider_b03.0c93c1a.png">
                        </figure>
                    </div>
                </div>
            </div>
            <div class="slick-slide">
                <div class="content">
                    <figure class="text_d1"><img
                            :src="getCurrentLanguage() === 'en'? require('../images/en-slider_text_d1.png'): require('../images/slider_text_d1.4f3f307.png')"
                            class="lazyLoad">
                    </figure>
                    <figure class="text_d2"><img
                            :src="getCurrentLanguage() === 'en'? require('../images/en-slider_text_d2.png') : require('../images/slider_text_d2.af8c52d.png')"
                            class="lazyLoad">
                    </figure>
                    <div class="slider-animation-4">
                        <figure class="d01"><img src="../images/slider_d01.5350fbb.png" class="lazyLoad"></figure>
                        <figure class="d02"><img src="../images/slider_d02.55dccda.png" class="lazyLoad"></figure>
                        <figure class="d03"><img src="../images/slider_d03.40d971f.png" class="lazyLoad"></figure>
                        <figure class="d04"><img src="../images/slider_d04.7f203f6.png" class="lazyLoad"></figure>
                        <figure class="d05"><img src="../images/slider_d05.3717bba.png" class="lazyLoad"></figure>
                        <figure class="d06"><img src="../images/slider_d06.6187751.png" class="lazyLoad"></figure>
                    </div>
                </div>
            </div>
        </Slick>      
      <div class="intro-cm-wrap">
        <div id="js-intro-cm" class="intro-cm-main">
            <div class="intro-cm-content">
                <h2 class="intro-cm-title">{{ $tt('合作模式') }}</h2>
                <hgroup class="intro-cm-text is-text-1" :class="getContent === 0 ? 'is-active' : ''">
                    <h3>{{ $tt('游戏API对接') }}</h3>
                    <p>
                        <span>{{$tt('八大游戏类型')}}，</span> <span>{{ $tt('区块链、视讯、电子、棋牌、') }}</span> 
                        <span>{{$tt('捕鱼、体育、电竞、彩票，')}}</span>
                        <span>{{$tt('50间以上国际级游戏平台，破万款游戏，')}}</span> 
                        <span>{{$tt('皆可藉由API对接整合至您的游戏平台上。')}}</span>
                    </p> 
                    <button id="js-cm-b1">{{$tt('更多')}}</button>
                </hgroup>
                <hgroup class="intro-cm-text is-text-2" :class="getContent === 1 ? 'is-active' : ''">
                    <h3>{{ $tt('包网建置') }}</h3>
                    <p>
                        <span>{{ $tt('JNR提供近百款的模版，') }}</span> 
                        <span>{{ $tt('快速稳定的数据线路') }}</span> 
                        <span>{{ $tt('以及强大的系统防护，') }}</span>
                        <span>{{ $tt('专业的技术团队7x24随时为您服务，') }}</span> 
                        <span>{{ $tt('让您的站点能够站上高峰问鼎全球。') }}</span>
                    </p> 
                    <button id="js-cm-b2">{{ $tt('更多') }}</button>
                </hgroup> 
                <button @click="setContent(0)" class="intro-cm-prev" :class="getContent === 0 ? 'is-active' : ''"></button> 
                <button @click="setContent(1)" class="intro-cm-next" :class="getContent === 0 ? 'is-active' : ''"></button>
            </div>
        </div>
      </div>
      <div class="intro-cm-popup popup-wrap">
        <div class="popup-main">
            <div class="popup-content">
                <div id="js-cm-c1" class="popup-text">
                    <div>
                        <!-- <figure><img src="../images/cm_popup_img01.80b5d27.png" class="lazyLoad"></figure> -->
                        <hgroup>
                            <h2>{{ $tt('游戏API对接') }}</h2>
                            <p><span>{{ $tt('JNR与多家国际游戏商合作，') }}</span> 
                                <span>{{ $tt('丰富多元的游戏类型，拥上万款游戏，') }}</span> 
                                <span>{{ $tt('我们将是您最有力的合作伙伴。') }}</span></p>
                        </hgroup>
                    </div>
                </div>
                <div id="js-cm-c2" class="popup-text">
                    <div>
                        <!-- <figure><img src="../images/cm_popup_img02.cab5048.png" class="lazyLoad"></figure> -->
                        <hgroup>
                            <h2>{{ $tt('包网建站') }}</h2>
                            <p>
                                <span>{{ $tt('最多元化的设计风格，最齐全的网站配色，') }}</span> 
                                <span>{{ $tt('最多样化的版型配置，') }}</span> 
                                <span>{{ $tt('JNR提供给您最完整具时尚、') }}</span>
                                <span>{{ $tt('热门的版型设计，您的需求我们能够一次满足。') }}</span></p>
                        </hgroup>
                    </div>
                </div> <button class="btn-prev"></button> <button class="btn-next"></button> <button
                    class="btn-close"></button>
            </div>
        </div>
    </div>
    </section>
    <section id="js-intro-pd" class="intro-middle-wrap">
        <!-- <div class="intro-pd-wrap-before"> {{ $tt('产品类型') }}</div> -->
        <div class="intro-pd-wrap">
            <div class="intro-pd-main">
                <div class="pd-nav" :class="isEnPdNav()">
                    <span class="pd-title">{{ $tt('产品类型') }}</span>
                    <ul rel="intro-pd-scroll">
                        <li @click="setProductTypeActive(0)" class="is-blockchain" 
                        :class="isProductTypeActive === 0 ? 'is-active' : ''"><span>{{ $tt('区块链') }}</span></li>
                        <li @click="setProductTypeActive(1)" class="is-live"
                        :class="isProductTypeActive === 1 ? 'is-active' : ''"><span>{{ $tt('视讯') }}</span></li>
                        <li @click="setProductTypeActive(2)" class="is-casino"
                        :class="isProductTypeActive === 2 ? 'is-active' : ''"><span>{{ $tt('电子') }}</span></li>
                        <li @click="setProductTypeActive(3)" class="is-card"
                        :class="isProductTypeActive === 3 ? 'is-active' : ''"><span>{{$tt('棋牌')}}</span></li>
                        <li @click="setProductTypeActive(4)" class="is-fishing"
                        :class="isProductTypeActive === 4 ? 'is-active' : ''"><span>{{ $tt('捕鱼') }}</span></li>
                        <li @click="setProductTypeActive(5)" class="is-sports"
                        :class="isProductTypeActive === 5 ? 'is-active' : ''"><span>{{ $tt('体育') }}</span></li>
                        <li @click="setProductTypeActive(6)" class="is-esports"
                        :class="isProductTypeActive === 6 ? 'is-active' : ''"><span>{{ $tt('电竞') }}</span></li>
                        <li @click="setProductTypeActive(7)" class="is-lottery"
                        :class="isProductTypeActive === 7 ? 'is-active' : ''"><span>{{ $tt('彩票') }}</span></li>
                    </ul>
                </div>
                <div class="pd-content">
                    <div class="is-blockchain" :class="isProductTypeActive === 0 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('区块链') }}</h2>
                            <p>
                                <span>{{ $tt('BB区块链xSHA加密技术，多重加密无法串改，') }}</span> 
                                <span>{{ $tt('领先业界，缔造全球娱乐飨宴，尽在JNR。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                    <div class="is-live" :class="isProductTypeActive === 1 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('真人视讯') }}</h2>
                            <p>
                                <span>{{ $tt('最据临场感真人荷官发牌，24小时线上即时开牌不间断，') }}</span> 
                                <span>{{ $tt('所有好玩新事物尽在JNR。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                    <div class="is-casino" :class="isProductTypeActive === 2 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('电子游戏') }}</h2>
                            <p>
                                <span>{{ $tt('JNR与30家以上国际级游戏商合作，') }}</span> 
                                <span>{{ $tt('破万款电子游戏，随君挑选。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                    <div class="is-card" :class="isProductTypeActive === 3 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('棋牌游戏') }}</h2>
                            <p>
                                <span>{{ $tt('从明清时期盛行至今，玩法多元丰富') }}</span> 
                                <span>{{ $tt('斗地主、炸金花、牛牛，依然稳坐热搜排行榜，') }}</span> 
                                <span>{{ $tt('深受华人地区玩家喜爱。') }}</span></p>
                        </hgroup>
                    </div>
                    <div class="is-fishing" :class="isProductTypeActive === 4 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('捕鱼游戏') }}</h2>
                            <p>
                                <span>{{ $tt('现今电玩城里最火红的游戏类型，') }}</span> 
                                <span>{{ $tt('透由剧情以炮弹系统攻击，捕获成功，') }}</span>
                                <span>{{ $tt('鱼儿们将化成數不尽的金币，塞满屏幕，欢乐无比。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                    <div class="is-sports" :class="isProductTypeActive === 5 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('体育赛事') }}</h2>
                            <p>
                                <span>{{ $tt('提供上万场体育赛事投注，覆盖世界各地赛事，') }}</span> 
                                <span>{{ $tt('让球、大小、半全场、波胆、单双、总入球、连串过关等多元竞猜，') }}</span>
                                <span>{{ $tt('年创百亿商机等您来+1。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                    <div class="is-esports" :class="isProductTypeActive === 6 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('电子竞技') }}</h2>
                            <p>
                                <span>{{ $tt('提供时下最流行的电子竞技，拥有顶尖的技术支持与令人惊叹的视觉界面。') }}</span> 
                                <span>{{ $tt('让您的电竞玩家轻松上手，一目了然，轻松投注。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                    <div class="is-lottery" :class="isProductTypeActive === 7 ? 'is-active' : ''">
                        <hgroup>
                            <h2>{{ $tt('彩票游戏') }}</h2>
                            <p>
                                <span>{{ $tt('JNR多样独家创新玩法，彩种丰富多元；') }}</span> 
                                <span>{{ $tt('公平可验证的区块链技术，界面简单易懂，新世代玩法不容错过。') }}</span>
                            </p>
                        </hgroup>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="js-intro-brand" class="intro-brand-wrap">
      <span class="brand-title">{{$tt('品牌优势')}}</span>
      <div class="intro-brand-main">
          <Slick class="intro-brand-list removeTextNodes slick-slider" ref="slick" 
          :options="slickOptions">
            <div class="intro-brand-item is-style-1 slick-slide slick-active" data-slick-index="1">
                          <figure><img src="../images/brand_icon01.57eb35a.png" class="lazyLoad"></figure>
                          <hgroup>
                              <h2>{{ $tt('世界顶尖机房') }}</h2>
                              <p>
                                <span>{{ $tt('7x24小时全面监控，核心节点极速网络，') }}</span> 
                                <span>{{ $tt('多重防护，使您安心的好选择。') }}</span></p> 
                                <button @click="setPopupIndex(0)"
                                  tabindex="0">{{ $tt('更多') }}</button>
                          </hgroup>
                      </div>
                      <div class="intro-brand-item is-style-2 slick-slide slick-active" data-slick-index="2">
                          <figure><img src="../images/brand_icon02.0a0c7eb.png" class="lazyLoad"></figure>
                          <hgroup>
                              <h2>{{ $tt('智能数位管理后台') }}</h2>
                              <p>
                                <span>{{ $tt('整合最完整的玩家游戏数据、提供最全方位的金流动向分析，') }}</span> 
                                <span>{{ $tt('揭露第一手最新游戏资讯，让您随时掌握，赢得先机。') }}</span></p>
                              <button @click="setPopupIndex(1)" tabindex="0">{{ $tt('更多') }}</button>
                          </hgroup>
                      </div>
                      <div class="intro-brand-item is-style-3 slick-slide slick-active" data-slick-index="3">
                          <figure><img src="../images/brand_icon03.07eacf4.png" class="lazyLoad"></figure>
                          <hgroup>
                              <h2> {{ $tt('时尚多元前台模版') }} </h2>
                              <p>
                                <span> {{ $tt('JNR提供近百款的模版, 各式版型风格,') }}</span> 
                                <span> {{ $tt('众多色系搭配') }}, {{$tt('展现出个人品牌风格或协助制作仿站')}}.</span>
                              </p> 
                              <button tabindex="0">{{ $tt('更多') }}</button>
                          </hgroup>
                      </div>
                      <div class="intro-brand-item is-style-4 slick-slide slick-active" data-slick-index="4">
                          <figure><img src="../images/brand_icon04.11930be.png" class="lazyLoad"></figure>
                          <hgroup>
                              <h2>{{ $tt('H5移动端APP') }}</h2>
                              <p><span>{{ $tt('随登即玩，一机在手，快乐随时拥有。') }}</span></p> <button @click="setPopupIndex(2)" tabindex="0">{{ $tt('更多') }}</button>
                          </hgroup>
                      </div>
                      <div class="intro-brand-item is-style-5 slick-slide slick-active" data-slick-index="5">
                          <figure><img src="../images/brand_icon05.36c83f4.png" class="lazyLoad"></figure>
                          <hgroup>
                              <h2>{{ $tt('专业的技术服务团队') }}</h2>
                              <p>
                                <span>{{ $tt('全年365天，7x24小时，') }}</span> 
                                <span>{{ $tt('专业技术团队随时为您服务。') }}</span></p> <button @click="setPopupIndex(3)"
                                  tabindex="0">{{ $tt('更多') }}</button>
                          </hgroup>
                      </div>       
          </Slick>
          <div id="brand-popup-1" class="intro-brand-popup popup-wrap" 
          :class="isPopupActive === 0 ? 'is-active' : ''" >
              <div class="popup-main">
                  <div class="popup-content">
                      <div class="popup-text">
                          <hgroup>
                              <h2>{{ $tt('世界顶尖机房') }}</h2>
                              <p>{{ $tt('JNR自建顶尖高防数据中心，全球布局光纤缆线，数据中心拥全球国际稳定线路，完美防护，顶尖网络设施就在JNR。') }}</p>
                          </hgroup>
                      </div> 
                      <button @click="setPopupIndex(3)" class="btn-prev"></button> 
                      <button @click="setPopupIndex(1)" class="btn-next"></button> 
                      <button @click="setPopupIndex(-1)" class="btn-close"></button>
                  </div>
              </div>
          </div>
          <div id="brand-popup-2" class="intro-brand-popup popup-wrap"
          :class="isPopupActive === 1 ? 'is-active' : ''">
              <div class="popup-main">
                  <div class="popup-content">
                      <div class="popup-text">
                          <hgroup>
                              <h2>{{ $tt('智能数位管理后台') }}</h2>
                              <p>{{ $tt('JNR提供最完整的数位管理后台系统，让您洞悉玩家游戏动态，掌握资金来龙去脉，随时调整运营方针。') }}</p>
                          </hgroup>
                          <figure><img src="../images/brand_popup_bg02.aa10495.png" class="lazyLoad"> <img
                                  src="../images/brand_popup_bg02_t.0528b36.png" class="lazyLoad"> <img
                                  src="../images/brand_popup_bg02_m.185491d.png" class="lazyLoad"></figure>
                      </div> 
                      <button @click="setPopupIndex(0)" class="btn-prev"></button> 
                      <button @click="setPopupIndex(2)" class="btn-next"></button> 
                      <button @click="setPopupIndex(-1)"
                          class="btn-close"></button>
                  </div>
              </div>
          </div>
          <div id="brand-popup-4" class="intro-brand-popup popup-wrap"
          :class="isPopupActive === 2 ? 'is-active' : ''">
              <div class="popup-main">
                  <div class="popup-content">
                      <div class="popup-text">
                          <hgroup>
                              <h2>{{ $tt('H5移动端APP') }}</h2>
                              <p>{{ $tt('运用扫脸、指纹，手势密码快速登入，随点即玩，让您的娱乐永不断线。') }}</p>
                          </hgroup>
                      </div> 
                      <button @click="setPopupIndex(1)" class="btn-prev"></button>
                      <button @click="setPopupIndex(3)" class="btn-next"></button> 
                      <button @click="setPopupIndex(-1)"
                          class="btn-close"></button>
                  </div>
              </div>
          </div>
          <div id="brand-popup-5" class="intro-brand-popup popup-wrap"
          :class="isPopupActive === 3 ? 'is-active' : ''">
              <div class="popup-main">
                  <div class="popup-content">
                      <div class="popup-text">
                          <hgroup>
                              <h2>{{ $tt('专业的技术服务团队') }}</h2>
                              <p>{{ $tt('JNR提供7x24小时专人线上咨询，以提升客户满意度为最高宗旨，而提供最全方位的技术服务是我们对您的坚持。') }}</p>
                          </hgroup>
                      </div> 
                      <button @click="setPopupIndex(2)" class="btn-prev"></button> 
                      <button @click="setPopupIndex(0)" class="btn-next"></button> 
                      <button @click="setPopupIndex(-1)"
                          class="btn-close"></button>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <section id="js-intro-partner" class="intro-partner-wrap">
        <span class="partner-title">{{ $tt('合作伙伴') }}</span>
        <div class="intro-partner-main">
            <div class="intro-partner-filter">
                <Slick class="filter-nav removeTextNodes slick-slider" ref="slickPartner" :options="slickPartner">
                        <div class="is-active slick-slide slick-current slick-active" @click=setPartnerActive(0)>
                            <div class="filter-btn" :class="isPartnerActive == 0 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="0">{{ $tt('全部') }}</a></div>
                        </div>
                        <div class="slick-slide" @click=setPartnerActive(1)>
                            <div class="filter-btn" :class="isPartnerActive == 1 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="-1">{{ $tt('电子') }}</a></div>
                        </div>
                        <div class="slick-slide" @click=setPartnerActive(2)>
                            <div class="filter-btn" :class="isPartnerActive == 2 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="-1">{{ $tt('体育') }}</a></div>
                        </div>
                        <div class="slick-slide" @click=setPartnerActive(3)>
                            <div class="filter-btn" :class="isPartnerActive == 3 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="-1">{{ $tt('棋牌') }}</a></div>
                        </div>
                        <div class="slick-slide" @click=setPartnerActive(4)>
                            <div class="filter-btn" :class="isPartnerActive == 4 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="-1">{{ $tt('视讯') }}</a></div>
                        </div>
                        <div class="slick-slide" @click=setPartnerActive(5)>
                            <div class="filter-btn" :class="isPartnerActive == 5 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="-1">{{ $tt('彩票') }}</a></div>
                        </div>
                        <div class="slick-slide" @click=setPartnerActive(6)>
                            <div class="filter-btn" :class="isPartnerActive == 6 ? 'is-active': ''"><a href="javascript:void(0)" tabindex="-1">{{ $tt('捕鱼') }}</a></div>
                        </div>                   
                </Slick>
                <div class="filter-sort">
                    <div class="filter-content">
                        <div v-for="logo in filterLogo" :key="logo.ls_id"
                            class="filter-item item" 
                            :class="getLogoClass(logo)">
                            <img :src="logo.ld_img"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <button class="btn-top" style="display: inline-block;" @click="goToTop()"></button>
  </main>
    <span class="overlay" 
            :class="getMainActive ? 'is-active' : 
            filterActive ? 'is-active' : ''" @click="hideMenu()"></span>
  </div>
  
  
</template>


<script type="application/javascript">
import { mapGetters } from "vuex";
import Swiper from "vux/src/components/swiper/swiper.vue";
import SwiperItem from "vux/src/components/swiper/swiper-item.vue";
import jquery from '../js/jquery.min.js'
import Slick from 'vue-slick';
import config from '../config';

export default {
  data() {
    return {
      currentIndex: 0,
      productTypeIndex: 0,
      popupIndex: -1,
      contentActive: 0,
      slickOptions: {},
      slickIntro: {},
      slickPartner: {},
      partnerActiveIndex: 0,
      logoData: [],
      currentLang: ''
    };
  },
  computed: {
    ...mapGetters(["getActiveMenu", "getMainActive", "filterActive"]),
    isProductTypeActive(){
        return this.productTypeIndex;
    },
    isPopupActive(){
        return this.popupIndex
    },
    getContent(){
        return this.contentActive;
    },
    isPartnerActive(){
        return this.partnerActiveIndex;
    },
    filterLogo(){
        if (this.partnerActiveIndex === 0){
            return config.logoData;
        }else if (this.partnerActiveIndex === 1){
            return config.logoData.filter(logo => logo.ld_casino === 1)
        }else if (this.partnerActiveIndex === 2){
            return config.logoData.filter(logo => logo.ld_sports === 1)
        }else if (this.partnerActiveIndex === 3){
            return config.logoData.filter(logo => logo.ld_card === 1)
        }else if (this.partnerActiveIndex === 4){
            return config.logoData.filter(logo => logo.ld_live === 1)
        }else if (this.partnerActiveIndex === 5){
            return config.logoData.filter(logo => logo.ld_lottery === 1)
        }else if (this.partnerActiveIndex === 6){
            return config.logoData.filter(logo => logo.ld_fishing === 1)
        }
    }
  },
  watch: {
    getActiveMenu (newVal, oldVal) {
        this.goToSection(newVal)
    }
  },
  components: {
    Swiper,
    SwiperItem,
    Slick,
  },
  methods: {
    isEnPdNav(){
        this.currentLang = localStorage.getItem('language');
        return this.currentLang == 'ch' ? '' : 'pd-nav-en';
    },
    goToSection(newVal){
        var r = $(".header-wrap").outerHeight();  
        document.documentElement.scrollTop = 0      
        if (newVal === 2){
            this.$nextTick(()=> {
                $('html, body').stop().animate({
                    scrollTop: $("#js-intro-cm").offset().top - r
                }, 1000)
            })
        }else if (newVal === 3){
            this.$nextTick(()=> {
                $('html, body').stop().animate({
                    scrollTop: $("#js-intro-pd").offset().top - r
                }, 1000)
            })
        }else if (newVal === 4){            
            this.$nextTick(()=> {
                $('html, body').stop().animate({
                    
                    scrollTop: $("#js-intro-brand").offset().top - r
                }, 1000)
            })            
        }else if (newVal === 5){
            console.log("Partner")
            this.$nextTick(()=> {
                $('html, body').stop().animate({
                    scrollTop: $("#js-intro-partner").offset().top - r
                }, 1000)
            });
        }
    },
    hideMenu(){
        this.$store.commit('setFilterActive', false)
        this.$store.commit('setMainMenuActive', false)
    },
    getLogoClass(logo){
        let classNames = '';
        if (logo.ld_casino === 1){
            classNames+= ' is-casino '
        }
        if (logo.ld_sports === 1){
            classNames+= ' is-sports '
        }
        if (logo.ld_card === 1){
            classNames+= ' is-card '
        }
        if (logo.ld_live === 1){
            classNames+= ' is-live '
        }
        if (logo.ld_lottery === 1){
            classNames+= ' is-lottery '
        }
        if (logo.ld_fishing === 1){
            classNames+= ' is-fishing '
        }
        if (logo.ld_mahjong === 1){
            classNames+= ' is-mahjong '
        }
        return classNames.trim();
    },
    setContent(index){
        this.contentActive = index
    },
    setPopupIndex(index){
        this.popupIndex = index
    },
    goToTop(){
        jquery('html, body').animate({
                    scrollTop: jquery("#js-intro-cm").offset().top
            }, 1000);
    },
    setProductTypeActive(index){
        this.productTypeIndex = index;
    },
    setPartnerActive(index){
        this.partnerActiveIndex = index;
    },
    getCurrentIndex(event){
      this.currentIndex = event;
    },
    getCurrentLanguage(){
      let lang = window.localStorage.getItem('language')      
      return lang
    },
  },
  created() {
    this.slickIntro = {
        dots: true,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay : false,
    };
    this.slickOptions = {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        rows: 2,
        slidesPerRow: 3,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    rows: 1,
                    slidesPerRow: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    rows: 1,
                    slidesPerRow: 1
                }
            }
        ]
    };
    this.slickPartner = {
        dots: false,
        infinite: false,
        arrows: false,
        touchMove: false,
        swipe: false,
        swipeToSlide: false,
        variableWidth: true,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: true,
                swipe: true,
                touchMove: true,
                swipeToSlide: true,
                infinite: true
            }
        }]

    };
    this.logoData = [...config.logoData]
  },
  mounted () {
    this.productTypeIndex = 0;
    this.popupIndex = -1;
    this.goToSection(this.getActiveMenu)
   
    $(".intro-slider-wrap").not(".slick-initialized").slick({
                                autoplay: false,
                                autoplaySpeed: 300,
                                dots: true,
                                arrows: true,
                                adaptiveHeight: true
                            });
    $(".filter-nav").not(".slick-initialized").slick({
        dots: false,
        infinite: false,
        arrows: false,
        touchMove: false,
        swipe: false,
        swipeToSlide: false,
        variableWidth: true,
        responsive: [{
            breakpoint: 991,
            settings: {
                arrows: true,
                swipe: true,
                touchMove: true,
                swipeToSlide: true,
                infinite: true
            }
        }]

    })
  },
}
</script>

<style scoped>
@import "../css/coopmode.css";
</style>